import { render, staticRenderFns } from "./PaymentAxisPermission.vue?vue&type=template&id=54f65da5"
import script from "./PaymentAxisPermission.vue?vue&type=script&lang=js"
export * from "./PaymentAxisPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports